import AppConsts, { AppConfiguration } from "./appconst"
import Util from "@utils/utils"

declare let abp: any

class SignalRAspNetCoreHelper {
  initSignalR() {
    const encryptedAuthToken = abp.utils.getCookieValue(
      AppConsts.authorization.encrptedAuthTokenName
    )
    abp.signalr = {
      autoConnect: true,
      connect: undefined,
      hubs: undefined,
      qs:
        AppConsts.authorization.encrptedAuthTokenName +
        "=" +
        encodeURIComponent(encryptedAuthToken),
      remoteServiceBaseUrl: AppConfiguration.remoteServiceBaseUrl,
      url: "signalr",
    }
    abp.booking = {
      on: undefined,
      autoConnect: true,
      connect: undefined,
      hubs: undefined,
      qs:
        AppConsts.authorization.encrptedAuthTokenName +
        "=" +
        encodeURIComponent(encryptedAuthToken),
      remoteServiceBaseUrl: AppConfiguration.remoteServiceBaseUrl,
      url: "signalr-hubs/booking",
    }
    // Notification Center hub (R5.1/R6.2): nhận realtime "ReceiveNotification" để tăng unread không reload.
    abp.notification = {
      on: undefined,
      autoConnect: true,
      connect: undefined,
      hubs: undefined,
      qs:
        AppConsts.authorization.encrptedAuthTokenName +
        "=" +
        encodeURIComponent(encryptedAuthToken),
      remoteServiceBaseUrl: AppConfiguration.remoteServiceBaseUrl,
      url: "signalr-hubs/notification",
    }
    Util.loadScript(
      AppConfiguration.appBaseUrl + "assets/abp.signalr-client-custom.js"
    )
  }
}
export default new SignalRAspNetCoreHelper()
